export default [{
  label: 'common.enrollment',
  href: '',
  description: null,
  customClass: '',
  prefixImg: '',
  subMenu: [
    {
      label: 'common.deadlines',
      href: '/covered-california/deadline',
      description: null,
      customClass: '',
      prefixImg: '',
      subMenu: []
    },
    {
      label: 'common.openEnrollmentPeriod',
      href: '/covered-california-enrollment/open-enrollment',
      description: null,
      customClass: '',
      prefixImg: '',
      subMenu: []
    },
    {
      label: 'common.specialEnrollmentPeriod',
      href: '/covered-california-enrollment/open-enrollment/special-enrollment',
      description: null,
      customClass: '',
      prefixImg: '',
      subMenu: []
    },
    {
      label: 'common.qualifyingEvents',
      href: '/covered-california/life-events',
      description: null,
      customClass: '',
      prefixImg: '',
      subMenu: []
    },
    {
      label: 'nav.reportingChanges',
      href: '/covered-california/application/report-changes',
      description: null,
      customClass: '',
      prefixImg: '',
      subMenu: []
    }
  ]
},
{
  label: 'nav.affordableCare',
  href: '/affordable-care-act',
  description: null,
  customClass: '',
  prefixImg: '',
  subMenu: [
    {
      label: 'nav.incomeLimitsCharts',
      href: '/covered-california/income-limits',
      description: null,
      customClass: '',
      prefixImg: '',
      subMenu: []
    },
    {
      label: 'common.governmentDiscounts',
      href: '/covered-california/subsidy-tax-credits',
      description: null,
      customClass: '',
      prefixImg: '',
      subMenu: []
    },
    {
      label: 'nav.penaltyForUninsured',
      href: '/covered-california/uninsured-penalty',
      description: null,
      customClass: '',
      prefixImg: '',
      subMenu: []
    },
    {
      label: 'nav.irsForm1095a',
      href: '/covered-california/irs-form-1095',
      description: null,
      customClass: '',
      prefixImg: '',
      subMenu: []
    },
    {
      label: 'nav.freePreventiveCare',
      href: '/obamacare/preventive-care',
      description: null,
      customClass: '',
      prefixImg: '',
      subMenu: []
    }
  ]
},
{
  label: 'nav.resources',
  href: '',
  description: null,
  customClass: '',
  prefixImg: '',
  subMenu: [
    {
      label: 'nav.faq',
      href: '/faq',
      description: null,
      customClass: '',
      prefixImg: '',
      subMenu: []
    },
    {
      label: 'Health Care Blog',
      href: '/blog',
      description: null,
      customClass: '',
      prefixImg: '',
      subMenu: []
    },
    {
      label: 'nav.hmoVsPpo',
      href: '/covered-california/plans/hmo-or-ppo',
      description: null,
      customClass: '',
      prefixImg: '',
      subMenu: []
    },
    {
      label: 'nav.saveWithHmo',
      href: '/is-it-time-to-switch-to-an-hmo-plan',
      description: null,
      customClass: '',
      prefixImg: '',
      subMenu: []
    },
    {
      label: 'nav.zeroDollarPlans',
      href: '/blog/free-health-insurance',
      description: null,
      customClass: '',
      prefixImg: '',
      subMenu: []
    },
    {
      label: 'nav.selfEmployedOptions',
      href: '/blog/self-employed-health-insurance',
      description: null,
      customClass: '',
      prefixImg: '',
      subMenu: []
    },
  ]
}];
